import { useContext } from 'react';
import { AuthContext, type AuthState } from '../context/AuthContext';

/**
 * Read the auth context.
 *
 * The throw is the useful part: it turns "why is user undefined?" into a
 * precise error naming the missing provider, at the exact component that
 * needs it.
 */
export function useAuth(): AuthState {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used inside an <AuthProvider>');
  }

  return context;
}
